import { Directive } from '@angular/core';
import { ToggleDirective } from './toggle.directive';

@Directive({
  selector: '[rlToggleGroup]'
})
export class ToggleGroupDirective {

  elements : ToggleDirective[] = [];

  closeAll = () => this.elements.forEach(e => e.onClose());

  openAll = () => this.elements.forEach(e => e.onOpen());
}
